<template>
  <div><slot></slot></div>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
import { loadGLTF } from '../../Reusable/loadGLTF'
import { LoadingManager } from '../../Reusable/LoadingManager'
import { ShaderCubeChromatics } from '../../Reusable/ShaderCubeChromatics'
import { MeshMatcapMaterial, DoubleSide, TextureLoader } from 'three'

export default {
  mixins: [O3DG2],
  props: {
  },
  data () {
    return {
      floor: false,
      layouts: {}
    }
  },
  created () {
    let texLoader = new TextureLoader(LoadingManager)
    // this.brown = new MeshMatcapMaterial({ color: 0xffffff, side: DoubleSide, matcap: texLoader.load(require('./matcap/brown.png')) })
    // this.yellow = new MeshMatcapMaterial({ color: 0xffd743, side: DoubleSide, matcap: texLoader.load(require('./matcap/bright-yellow.png')) })
    // this.pink = new MeshMatcapMaterial({ color: 0xffffff, side: DoubleSide, matcap: texLoader.load(require('./matcap/pink.jpg')) })
    this.floor = new MeshMatcapMaterial({ color: 0xffffff, side: DoubleSide, matcap: texLoader.load(require('./matcap/silver.png')) })
    // this.celing = new MeshMatcapMaterial({ color: 0xffffff, side: DoubleSide, matcap: texLoader.load(require('./matcap/bright-yellow.png')) })
  },
  methods: {
    // download (glb) {
    //   var link = document.createElement( 'a' );
		// 	link.style.display = 'none';
		// 	document.body.appendChild( link ); // Firefox workaround, see #6594

		// 	function save( blob, filename ) {
		// 		link.href = URL.createObjectURL( blob );
		// 		link.download = filename;
		// 		link.click();
		// 		// URL.revokeObjectURL( url ); breaks Firefox...
		// 	}
		// 	this.saveStr = function saveString( text, filename ) {
		// 		save( new Blob( [ text ], { type: 'text/plain' } ), filename );
		// 	}

		// 	this.saveArrBuff = function saveArrayBuffer( buffer, filename ) {
		// 		save( new Blob( [ buffer ], { type: 'application/octet-stream' } ), filename );
    //   }
    //   let { GLTFExporter } = require('three/examples/jsm/exporters/GLTFExporter.js')
    //   var gltfExporter = new GLTFExporter({
    //     binary: true,
    //   });

    //   gltfExporter.parse(glb.scene, (result) => {
    //     if ( result instanceof ArrayBuffer ) {
    //       this.saveStr( result, 'scene.glb' );
    //     } else {
    //       var output = JSON.stringify( result, null, 2 );
    //       console.log( output );
    //       this.saveArrBuff( output, 'scene.gltf' );
    //     }
    //   })
    // },

    setup () {
      let flowerURL = require('file-loader!./glb/church-simple3.glb')
      let shaderCube = new ShaderCubeChromatics({ renderer: this.ctx.renderer, loop: this.onLoop, res: 64, resX: 64 })
      loadGLTF(flowerURL)
        .then((glb) => {
          glb.scene.traverse((item) => {
            if (item.isMesh) {
              if (item.name.indexOf('Cube') !== -1) {
                item.material = shaderCube.out.material
              }
              if (item.name.indexOf('Plane') !== -1) {
                item.material = this.floor
              }
            }
          })

          this.o3d.add(glb.scene)

          glb.scene.scale.x = 3.5
          glb.scene.scale.y = 3.5
          glb.scene.scale.z = 6
        })
    }
  },
  mounted () {
    this.setup()
  }
}
</script>

<style>

</style>